import React from "react";
import { MdLabelImportant } from "react-icons/md";
const Certificate = () => {
  return (
    <div className="w-full">
      <h2 className="text-[#22BEFF] text-2xl font-bold">কোর্স সার্টিফিকেট</h2>
      <div className="w-full border border-[#22BEFF33] mt-[1rem] rounded-md  gap-8 p-4">
        <div className="flex flex-col gap-4">
          <p className="text-gray-400 text-xl flex items-center">
            <MdLabelImportant className="text-[#22BEFF] text-base" /> আপনার প্রফেশনাল ক্যারিয়ারে গুরুত্বপূর্ণ সংযোজন হিসেবে কাজ করবে।
          </p>
          <p className="text-gray-400 text-xl flex items-center">
            <MdLabelImportant className="text-[#22BEFF] text-base" />
            যেকোনো চাকরির আবেদন বা ইন্টারভিউতে আপনাকে অগ্রাধিকার দেবে।
          </p>
          <p className="text-gray-400 text-xl flex items-center">
            <MdLabelImportant className="text-[#22BEFF] text-base" />
            আপনার CV বা LinkedIn প্রোফাইলকে আরও শক্তিশালী করে তুলবে।
          </p>
          <p className="text-gray-400 text-xl flex items-center">
            <MdLabelImportant className="text-[#22BEFF] text-base" />
            উচ্চশিক্ষা বা স্কলারশিপ আবেদনের ক্ষেত্রেও বিশেষ সুবিধা পাবেন।
          </p>
       
        </div>
      </div>
    </div>
  );
};

export default Certificate;
